import { HeaderUserDropdown } from '../HeaderUserDropdown';
import { PageHeader } from '../PageHeader';

interface Props {
  className?: string;
}

export function PageHeaderWithUser(props: Props) {
  return (
    <PageHeader className={props.className}>
      <HeaderUserDropdown />
    </PageHeader>
  );
}
